// src/components/atoms/VideoFullscreenButton.js

import React from "react";
import { IconButton } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

const VideoFullscreenButton = ({ isFullscreen, onClick }) => {
  return (
    <IconButton
      onClick={onClick}
      aria-label={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}
    >
      {isFullscreen ? (
        <FullscreenExitIcon sx={{ color: "white" }} />
      ) : (
        <FullscreenIcon sx={{ color: "white" }} />
      )}
    </IconButton>
  );
};

export default VideoFullscreenButton;
